import { ApiPromise } from '@/types';
import { HTTP } from '@/utils';

export interface PublisherPayload {
  title: string;
}

export interface PublisherFilterInterface {
  search?: string;
  page?: string | number;
  per_page?: number;
  order?: string;
  order_by?: string;
}

export default class AssessmentPublisherService {
  static resource = 'tenant/assessments/publishers';

  static getPublishers(filters?: PublisherFilterInterface): ApiPromise {
    let queryString = '';

    if (filters) {
      const params = new URLSearchParams();
      Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== '') {
          params.append(key, value.toString());
        }
      });
      queryString = `?${params.toString()}`;
    }

    return HTTP.get(`${this.resource}${queryString}`);
  }

  static getPublisher(id: number): ApiPromise {
    return HTTP.get(`${this.resource}/${id}`);
  }

  static createPublisher(payload: PublisherPayload): ApiPromise {
    return HTTP.post(this.resource, payload);
  }

  static updatePublisher(id: number, payload: PublisherPayload): ApiPromise {
    return HTTP.post(`${this.resource}/${id}`, payload);
  }

  static deletePublisher(id: number): ApiPromise {
    return HTTP.delete(`${this.resource}/${id}`);
  }
}
